/* eslint-disable @typescript-eslint/naming-convention */
import { APIRequestBody } from "@payment-client/interfaces/CorporateApi";
import { GlobalHeaderState } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";
import { CorporateWalletDetails } from "@swiggy-private/native-bridge";

export const getPlatform = (platform = "") => {
    switch (platform.toLowerCase()) {
        case "swiggy-android":
            return "PLATFORM_ANDROID";
        case "swiggy-ios":
            return "PLATFORM_IOS";
        case "swiggy-mweb":
            return "PLATFORM_WEB";
        case "swiggy-dweb":
            return "PLATFORM_DWEB";
        default:
            return "PLATFORM_INVALID";
    }
};

export const getCorporatePartnerId = (corporateWalletDetails?: CorporateWalletDetails): string => {
    return corporateWalletDetails?.partnerId || "";
};

export const generateCorporateDelinkRequestBody = (partnerId?: string): APIRequestBody => {
    const headers = GlobalHeaderState.getHeaders();
    if (isEmpty(headers) || isEmpty(partnerId)) {
        return {} as APIRequestBody;
    }

    return {
        general_context: {
            request_context: {
                request_id: "",
                client_id: "portal",
            },
            device_context: {
                device_id: GlobalHeaderState.getHeader("deviceId"),
                app_version_code: GlobalHeaderState.getHeader("version-code"),
                platform: getPlatform(GlobalHeaderState.getHeader("platform")),
                user_agent: getPlatform(GlobalHeaderState.getHeader("platform")),
            },
            location_context: {
                lat_lng: {
                    latitude: Number(GlobalHeaderState.getHeader("lat")),
                    longitude: Number(GlobalHeaderState.getHeader("lng")),
                },
                city_id: Number(GlobalHeaderState.getHeader("cityid")),
            },
            mp_context: {
                marketplace_id: "1",
                business_line_id: "1",
            },
        },
        consumer_context: {
            consumer_id: GlobalHeaderState.getHeader("userid"),
        },
        authentication_context: {
            tid: GlobalHeaderState.getHeader("tid"),
            token: GlobalHeaderState.getHeader("token"),
        },
        partner_id: partnerId,
    };
};
